import { render } from "./PaymentRefund.vue?vue&type=template&id=118e35ee&scoped=true"
import script from "./PaymentRefund.vue?vue&type=script&lang=js"
export * from "./PaymentRefund.vue?vue&type=script&lang=js"

import "./PaymentRefund.vue?vue&type=style&index=0&id=118e35ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118e35ee"]])

export default __exports__